export enum UserEndpoint {
  Base = '/users',
  Approve = '/approve',
  Reset = '/reset',
  Password = '/password',
  Roles = '/roles',
  Profile = '/profile',
  Search = '/search',
  Exports = '/exports',
  User = '/user',
  Upload = '/upload',
  Exists = '/exists',
  MicroSoft = '/microsoft',
  ActiveDirectory = '/active-directory',
  Hubs = '/hubs',
  DriverData = '/driver-data',
}
